import { createContext } from '@lit/context'

/** Close behavior a Drawer provides to composed close controls. */
export interface DrawerContext {
  requestClose: (trigger?: Event) => void
}

/** Context composed Drawer parts use to coordinate with their nearest Drawer. */
export const drawerContext = createContext<DrawerContext | undefined>(
  Symbol('nord-drawer'),
)
